export const DEFAULT_HEADER_HEIGHT = 52;

export const DEFAULT_ROW_HEIGHT = 52;

export const DEFAULT_GRID_FILTER_MODE = 'client';

export const DEFAULT_PAGINATION_MODE = 'client';
